import {
  UPDATE_LIVE_DISCUSSION,
  UPDATE_LIVE_DISCUSSION_SPREAD,
  PUBLISH_LIVE_DISCUSSION,
  START_LIVE_DISCUSSION,
  ADD_PARTICIPATION,
  UPDATE_PARTICIPATION,
  UPDATE_PARTICIPATION_SPREAD,
  NEW_TURN,
  PAUSE_LIVE_DISCUSSION,
  END_LIVE_DISCUSSION,
  RESTART_LIVE_DISCUSSION,
  POST_PARTICIPATION_SUMMARY,
  UPDATE_PARTICIPATION_SUMMARY,
  POST_CLASS_SUMMARY_LD,
  LOADING_LIVE_DISCUSSION,
  REMOVE_STUDENT_LD,
  REMOVE_STUDENTS_LD,
  UPDATE_TURN,
  POST_DRAFT_FEEDBACK_FOR_STUDENT,
  POST_FEEDBACK_FOR_STUDENT,
  UPDATE_FEEDBACK_FOR_STUDENT_LD,
  UPDATE_POINTS_SETTINGS_LIVE_DISCUSSION,
  UPDATE_STUDENT_POINT_SETTINGS,
  UPDATE_HAND_RAISES,
  LD_GIVE_POINT,
  LD_REMOVE_POINT,
  UPDATE_STUDENT_NOTES_LD,
  UPDATE_PRIVATE_TEACHER_NOTES_LD,
  SOCKET_UPDATE_QUEUE,
  UPDATE_NUDGES,
  SET_POLL,
  SET_VOTE,
  DELETE_POLL,
  UPDATE_LIVE_DISCUSSION_POLLS,
  UPDATE_LIVE_DISCUSSION_CIRCLE,
  UPDATE_PARTICIPATION_TURN_COUNT,
  MODERATOR_CHOSEN,
  RESET_MODERATOR,
  TOGGLE_QUEUE,
  UPDATE_DRAFT_STUDENT_ASSESSMENTS,
  UPDATE_STUDENT_ASSESSMENTS,
  LOADING_GRADES,
  TOGGLE_DISCUSSION_AUDIO,
  TOGGLE_PARTICIPATION_AUDIO,
  TOGGLE_PARTICIPATION_VIDEO,
  VIDEO_OFF_MUTE_PARTICIPATIONS,
  MUTE_PARTICIPATIONS,
  START_AUDIO_CONNECTION,
  END_AUDIO_CONNECTION,
  TEACHER_TAP_IN,
  TEACHER_TAP_OUT,
  RESET_PARTICIPATION_SUMMARY,
  UPDATE_LD_DETAILS,
  UPDATE_SPEAKER_COUNT,
  UPDATE_TURNS_POSITION,
  UPDATE_STUDENT_NUDGE,
  UPDATE_VERBAL_RECAP,
  SET_VERBAL_TRANSCRIPTION
} from './../../mutation-types';
import Vue from 'vue';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import { EventBus } from 'utils/event-bus';
import ld_state from './state';
import state from './state';

const clone = (el) => JSON.parse(JSON.stringify(el));

const defaultState = {
  studentSummary: clone(ld_state.grades.studentSummary),
};
// TODO: Modular function to retrieve a participation or something
const findParticipation = (state, participation_id) => {
  const { participations } = state.currentDiscussion;
  const participation = participations.find(
    (participation) => participation.id === participation_id
  );
  return participation || null;
};

export default {
  [UPDATE_LIVE_DISCUSSION](state, liveDiscussion) {
    // if liveDiscussion.updateParticipations === true, just update participations
    if (
      liveDiscussion.updateParticipationsOnly &&
      state.currentDiscussion.participations
    ) {
      state.currentDiscussion.participations = state.currentDiscussion.participations.concat(
        liveDiscussion.participations
      );
      return state;
    }
    // this replaces everything in live discussion but keeps participations
    // this is because the request for saving live discussion does
    // not return participations
    if (liveDiscussion.keepParticipations) {
      const { participations } = state.currentDiscussion;
      state.currentDiscussion = liveDiscussion;
      state.currentDiscussion.participations = participations;
      return state;
    }
    state.currentDiscussion = liveDiscussion;
    // necessary to make polls reactive. Polls come from another db call.
    Vue.set(state.currentDiscussion, 'polls', []);
    Vue.set(state.currentDiscussion, 'live_log', []);
    Vue.set(state.currentDiscussion, 'users_present', []);
    return state;
  },
  [UPDATE_VERBAL_RECAP] (state, recap) {
    state.currentDiscussion.genie_recap = recap;
    return state;
  },
  [SET_VERBAL_TRANSCRIPTION] (state, transcription) {
    state.currentDiscussion.transcriptions = transcription;
    return state;
  },
  [UPDATE_TURNS_POSITION](state, turns) {
    state.currentDiscussion.turns_in_circle = turns;
    return state;
  },
  [UPDATE_LIVE_DISCUSSION_POLLS](state, polls) {
    state.currentDiscussion.polls = polls;
    return state;
  },
  [UPDATE_POINTS_SETTINGS_LIVE_DISCUSSION](state, payload) {
    state.currentDiscussion.points_settings = payload;
    return state;
  },
  [UPDATE_STUDENT_POINT_SETTINGS](state, payload) {
    state.grades.studentSummary.points_settings.peer_rewards =
      payload.points_settings;
    return state;
  },
  // Activated by socket when a new student is selected to speak
  [NEW_TURN](state, payload) {
    // TODO: Delete when queue is in
    state.currentDiscussion.turns = payload.turns; // I suspect this is not needed
    // TODO: Delete when queue is in
    state.currentDiscussion.discussion_start_time = payload.discussion_start_time;
    // TODO: Delete when queue is in
    state.currentDiscussion.currently_active = payload.currently_active;
    // NOTE: Only keep this
    state.currentDiscussion.current_turn_id = payload.current_turn_id;

    const participation = find(state.currentDiscussion.participations, (p) => p.user.id === payload.currently_active);
    if (participation) {
      participation.turn_count = parseInt(participation.turn_count) + 1;
    }
    return state;
  },
  [PUBLISH_LIVE_DISCUSSION](state, status) {
    state.currentDiscussion.is_published = status;
    return state;
  },
  // TODO: start, pause, end, restart live disussion commits should be reviewed for deprecation
  // when new live is released
  // New Live MVP will only use is_ended
  [START_LIVE_DISCUSSION](state, discussion_start_time) {
    state.currentDiscussion.is_live = Boolean(discussion_start_time);
    state.currentDiscussion.discussion_start_time = discussion_start_time;
    return state;
  },
  [PAUSE_LIVE_DISCUSSION](state, discussion) {
    state.currentDiscussion.is_paused = discussion.is_paused;
    state.currentDiscussion.pauses = discussion.pauses;
    state.currentDiscussion.currently_active = discussion.currently_active;
    state.currentDiscussion.current_turn_id = discussion.current_turn_id;
    return state;
  },
  [END_LIVE_DISCUSSION](state, discussion) {
    state.currentDiscussion.is_ended = discussion.is_ended;
    state.currentDiscussion.is_live = discussion.is_live;
    state.currentDiscussion.currently_active = null;
    state.currentDiscussion.queue = [];
    state.currentDiscussion.turns_in_circle = [];
    state.currentDiscussion.teacher_tapped_in_id = null;
    state.currentDiscussion.discussion_time = discussion.discussion_time;

    state.currentDiscussion.participations.forEach((p) => {
      p.audio_is_enabled = false;
      p.video_is_enabled = false;
    });

    return state;
  },
  [RESTART_LIVE_DISCUSSION](state, discussion) {
    state.currentDiscussion.is_ended = discussion.is_ended;
    state.currentDiscussion.is_live = discussion.is_live;
    state.currentDiscussion.discussion_start_time = discussion.discussion_start_time;
    return state;
  },
  [ADD_PARTICIPATION](state, participation) {
    participation.turn_count = participation.turn_count || 0;
    if (!state.currentDiscussion.participations) {
      state.currentDiscussion.participations = [];
    }
    // Only add participation if it doesn't yet exist in the state
    const participations = [...state.currentDiscussion.participations];
    const index = findIndex(participations, { id: participation.id });
    if (index === -1) {
      state.currentDiscussion.participations.push(participation);
    }
    return state;
  },
  [UPDATE_PARTICIPATION](state, participation) {
    const participations = [...state.currentDiscussion.participations];
    const replaceIndex = findIndex(participations, { id: participation.id });

    if (replaceIndex !== -1) {
      participations[replaceIndex] = participation;
      state.currentDiscussion.participations = participations;
    }
    return state;
  },
  [UPDATE_PARTICIPATION_SPREAD](state, updates) {
    if (!state.currentDiscussion.participations) {
      state.currentDiscussion.participations = [];
    }
    const index = findIndex(
      state.currentDiscussion.participations,
      (p) => updates.id === p.id
    );
    const updatedParticipation = {
      ...state.currentDiscussion.participations[index],
      ...updates,
    };
    const isCorrectDiscussion =
      updatedParticipation.live_discussion_id === state.currentDiscussion.id;
    if (isCorrectDiscussion) {
      index !== -1
        ? state.currentDiscussion.participations.splice(
          index,
          1,
          updatedParticipation
        )
        : state.currentDiscussion.participations.push(updatedParticipation);
    }
    return state;
  },
  [UPDATE_SPEAKER_COUNT](state, payload) {
    const participation = find(state.currentDiscussion.participations, (p) => p.user.id === payload.participation.user.id);
    if (participation) {
      participation.turn_count = parseInt(participation.turn_count) + 1;
    }
    return state;
  },
  [POST_PARTICIPATION_SUMMARY](state, studentSummary) {
    state.grades.studentSummary = studentSummary;
    return state;
  },
  [UPDATE_PARTICIPATION_SUMMARY](state, payload) {
    const { currently_active } = payload;
    const summary = state.grades.studentSummary;

    if (summary.user_id === currently_active) {
      const participation = find(
        state.currentDiscussion.participations,
        (p) => p.user.id === payload.currently_active
      );
      const turn = find(
        state.currentDiscussion.turns_in_circle,
        (t) => t.participation.user.id === payload.currently_active
      );
      if (participation && turn) {
        const summary = state.grades.studentSummary;
        summary.times_spoken[turn.turn_type] += 1;
        summary.times_spoken.turns_total = parseInt(participation.turn_count);

        const updated_record = Object.assign({}, state.grades.studentSummary, summary);
        Vue.set(state, 'grades.studentSummary', updated_record);
      }
    }
  },
  // TODO: should use this in the future
  [RESET_PARTICIPATION_SUMMARY]() {
    Object.assign(state.grades.studentSummary, defaultState);
    return state;
  },
  [LOADING_GRADES](state, status) {
    state.grades.loading = status;
    return state;
  },
  [UPDATE_DRAFT_STUDENT_ASSESSMENTS](state, assessments) {
    state.grades.studentSummary.draft_assessments = assessments;
    return state;
  },
  [UPDATE_STUDENT_ASSESSMENTS](state, assessments) {
    state.grades.studentSummary.assessments = assessments;
    return state;
  },
  [POST_CLASS_SUMMARY_LD](state, classSummary) {
    state.grades.loading = false;
    state.grades.classSummary = classSummary;
    return state;
  },
  [LOADING_LIVE_DISCUSSION](state, status) {
    state.loading = status;
    return state;
  },
  [REMOVE_STUDENT_LD](state, user_id) {
    const index = state.currentDiscussion.participations.findIndex(
      (p) => p.user_id === user_id
    );
    if (index !== -1) {
      state.currentDiscussion.participations.splice(index, 1);
    }
    return state;
  },
  [REMOVE_STUDENTS_LD](state, participation_ids) {
    let ld_participations = state.currentDiscussion.participations.slice();
    ld_participations = ld_participations.filter(p => !participation_ids.includes(p.user_id));
    Vue.set(state.currentDiscussion, 'participations', ld_participations);
    return state;
  },
  [UPDATE_TURN](state, turn) {
    const participation = find(
      state.currentDiscussion.participations,
      (p) => p.id === turn.participation_id
    );

    if (!participation) {
      return state;
    }

    const turns = [...participation.turns];

    const turnToReplaceIndex = findIndex(turns, (t) => t.id === turn.id);

    if (turnToReplaceIndex !== -1) {
      turns[turnToReplaceIndex] = turn;
    }
    participation.turns = turns;
    return state;
  },
  [POST_DRAFT_FEEDBACK_FOR_STUDENT](state, feedback) {
    state.grades.studentSummary.draft_feedback_for_student = feedback;
    return state;
  },
  [POST_FEEDBACK_FOR_STUDENT](state, feedbackArray) {
    state.grades.studentSummary.feedback_for_student = feedbackArray;
    state.grades.studentSummary.draft_feedback_for_student = feedbackArray[0];
    return state;
  },
  [UPDATE_FEEDBACK_FOR_STUDENT_LD](state, participation) {
    const participationInState = find(
      state.currentDiscussion.participations,
      (p) => p.id === participation.id
    );
    if (participationInState) {
      participationInState.feedback_for_student = participation.feedback;
    }
    return state;
  },

  [UPDATE_HAND_RAISES](state, participation) {
    const participationInState = find(
      state.currentDiscussion.participations,
      (p) => p.id === participation.id
    );

    if (!participationInState) {
      return state;
    }

    const { hand_raises } = participation;
    participationInState.hand_raises = hand_raises;
    return state;
  },
  [LD_GIVE_POINT](state, reward) {
    const participationInState = find(
      state.currentDiscussion.participations,
      (p) => p.id === reward.participation_id
    );
    if (participationInState.rewards) {
      participationInState.rewards.push(reward);
    } else {
      participationInState.rewards = [reward];
    }
    return state;
  },
  [LD_REMOVE_POINT](state, removed_reward) {
    const participationInState = find(
      state.currentDiscussion.participations,
      (p) => p.id === removed_reward.participation_id
    );
    const rwd_Index = findIndex(
      participationInState.rewards,
      (reward) => reward.id === removed_reward.id
    );
    participationInState.rewards.splice(rwd_Index, 1);
    return state;
  },
  [UPDATE_STUDENT_NOTES_LD](state, content) {
    const clone = Object.assign({}, state.grades.studentSummary.notes, {
      content,
    });
    state.grades.studentSummary.notes = clone;
    return state;
  },
  [UPDATE_PRIVATE_TEACHER_NOTES_LD](state, observations) {
    state.grades.studentSummary.observations = observations;
    return state;
  },
  [SOCKET_UPDATE_QUEUE](state, { queue, queue_history, currently_active }) {
    state.currentDiscussion.queue = queue;
    state.currentDiscussion.queue_history = queue_history;
    state.currentDiscussion.currently_active = currently_active;
    EventBus.$emit('queueLoading', false);

    return state;
  },
  [SET_POLL](state, poll) {
    const polls = [...state.currentDiscussion.polls];
    const replaceIndex = findIndex(polls, { id: poll.id });
    if (replaceIndex !== -1) {
      polls[replaceIndex] = poll;
      state.currentDiscussion.polls = polls;
    } else {
      state.currentDiscussion.polls.unshift(poll);
    }
    return state;
  },
  [SET_VOTE](state, vote) {
    const poll = find(state.currentDiscussion.polls, { id: vote.poll_id });
    if (!poll) {
      return state;
    }
    if (!poll.votes) {
      poll.votes = [];
    }
    const vote_in_state = find(poll.votes, { id: vote.id });

    if (!vote_in_state) {
      poll.votes.push(vote);
    }
    return state;
  },
  [DELETE_POLL](state, pollID) {
    const pollIndex = findIndex(state.currentDiscussion.polls, { id: pollID });
    if (pollIndex === -1) {
      return state;
    }
    state.currentDiscussion.polls.splice(pollIndex, 1);
    return state;
  },
  [UPDATE_LIVE_DISCUSSION_CIRCLE](state, payload) {
    state.currentDiscussion.turns_in_circle = payload;
  },
  // TODO: can use an update participation spread function
  [UPDATE_PARTICIPATION_TURN_COUNT](state, { payload }) {
    const participation = findParticipation(state, payload.participation_id);
    if (participation) {
      if (parseInt(participation.turn_count) === 0) {
        state.currentDiscussion.live_log.push(
          `${participation.user.name} has joined the discussion for the first time.`
        );
      }
      /*if (studentDontSpeak) {
        participation.turn_count = parseInt(participation.turn_count) - 1;
      } else {
        participation.turn_count = parseInt(participation.turn_count) + 1;
      }*/
    }
  },
  [UPDATE_LIVE_DISCUSSION_SPREAD](state, payload) {
    Object.assign(state.currentDiscussion, payload);
  },
  ['ADD_USER_TO_PRESENCE_LIST'](state, user_id) {
    const { users_present } = state.currentDiscussion;
    const already_present = users_present.includes(user_id);
    if (!already_present) {
      users_present.push(user_id);
    }
  },
  ['REMOVE_USER_FROM_PRESENCE_LIST'](state, user_id) {
    const { users_present } = state.currentDiscussion;
    const index = users_present.findIndex((id) => id === user_id);
    if (index !== -1) {
      users_present.splice(index, 1);
    }
  },
  [MODERATOR_CHOSEN](state, user_id) {
    state.currentDiscussion.participations.forEach((p) => {
      p.is_moderator = false;
      if (p.user_id === user_id) {
        p.is_moderator = true;
      }
    });
    return state;
  },
  [RESET_MODERATOR](state, user) {
    if (user) {
      state.currentDiscussion.participations.forEach(
        (p) => (p.is_moderator = false)
      );
    }
    return state;
  },
  [TOGGLE_QUEUE](state, payload) {
    state.currentDiscussion.queue_is_active = payload.queue_is_active;
    return state;
  },
  [UPDATE_NUDGES](state, payload) {
    const participation = state.currentDiscussion.participations.find(
      (p) => p.id == payload.id
    );
    if (participation) {
      state.grades.studentSummary.nudges = payload.nudges;
    }
    return state;
  },
  [UPDATE_STUDENT_NUDGE](state, payload) {
    state.grades.studentSummary.nudges.push({
      time: Date.now(),
      message: payload.message,
    });
    return state;
  },
  [TOGGLE_DISCUSSION_AUDIO](state, payload) {
    if (state.currentDiscussion.id === payload.id) {
      state.currentDiscussion.audio_discussion_is_enabled = payload.audio_discussion_is_enabled;

      if (!payload.audio_discussion_is_enabled) {
        state.currentDiscussion.participations.forEach((p) => {
          p.audio_is_enabled = false;
          p.video_is_enabled = false;
        });
      }
    }

    return state;
  },
  [TOGGLE_PARTICIPATION_AUDIO](state, participation) {
    state.currentDiscussion.participations.forEach((p) => {
      if (p.id === participation.id) {
        p.audio_is_enabled = participation.audio_is_enabled;
        p.video_is_enabled = p.video_is_enabled;
      }
    });
    return state;
  },
  [TOGGLE_PARTICIPATION_VIDEO](state, participation) {
    state.currentDiscussion.participations.forEach((p) => {
      if (p.id === participation.id) {
        p.video_is_enabled = participation.video_is_enabled;
      }
    });
    return state;
  },
  [VIDEO_OFF_MUTE_PARTICIPATIONS](state, participations_to_update) {
    let array = [];
    state.currentDiscussion.turns_in_circle.filter((t) => {
      if (!participations_to_update.includes(t.participation_id)) {
        array.push(t);
      }
    });
    state.currentDiscussion.turns_in_circle = array;

    state.currentDiscussion.participations.forEach((p) => {
      participations_to_update.map((participation_id) => {
        if (p.id === participation_id) {
          p.audio_is_enabled = false;
          p.video_is_enabled = false;
        }
      });
    });
    return state;
  },
  [MUTE_PARTICIPATIONS](state) {
    state.currentDiscussion.participations.forEach((p) => {
      p.audio_is_enabled = false;
    });
    return state;
  },
  [START_AUDIO_CONNECTION](state, payload) {
    state.currentDiscussion.audio_config = JSON.parse(JSON.stringify(payload));
    return state;
  },
  [END_AUDIO_CONNECTION](state) {
    state.currentDiscussion.audio_config = null;
    return state;
  },
  [TEACHER_TAP_IN](state, payload) {
    state.currentDiscussion.teacher_tapped_in_id = payload.teacher_tapped_in_id;
    return state;
  },
  [TEACHER_TAP_OUT](state) {
    state.currentDiscussion.teacher_tapped_in_id = null;
    return state;
  },
  ['APPLAUSE_TURN'](state, payload) {
    const currentDiscussion = state.currentDiscussion;
    currentDiscussion.applause_turn = payload;
    const updated_record = Object.assign({}, state.currentDiscussion, currentDiscussion);
    Vue.set(state, 'currentDiscussion', updated_record);
    const summary = state.grades.studentSummary;
    if (summary.participation_id === payload.participationID) {

      const turn = find(
        state.currentDiscussion.turns_in_circle,
        (t) => t.participation.id === payload.participationID
      );
      if (turn) {
        summary.applause_count += 1;
      }
    }
    return state;
  },
  [UPDATE_LD_DETAILS](state, updatedKeys) {
    if (updatedKeys) {
      const updated_record = Object.assign({}, state.currentDiscussion, updatedKeys);
      Vue.set(state, 'currentDiscussion', updated_record);
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/liveDiscussions/mutations.js